var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequirementsRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 44.4141L26 42.4143L27.9998 44.4141L29.4141 42.9999L27.4142 41.0001L29.4144 38.9999L28.0002 37.5857L26 39.5858L23.9998 37.5857L22.5856 38.9999L24.5858 41.0001L22.5859 42.9999L24.0002 44.4141Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4345 33.409L29.4112 28.9135L27.9132 27.5884L25.3076 30.5338L23.9614 29.2584L22.5859 30.7103L25.4345 33.409Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4112 19.9135L25.4345 24.409L22.5859 21.7103L23.9614 20.2584L25.3076 21.5338L27.9132 18.5884L29.4112 19.9135Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 22H32V24H44V22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31H44V33H32V31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40H32V42H44V40Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9C10 7.34315 11.3431 6 13 6H41C42.6569 6 44 7.34315 44 9V12H47C48.6569 12 50 13.3431 50 15V51C50 52.6569 48.6569 54 47 54H19C17.3431 54 16 52.6569 16 51V48H13C11.3431 48 10 46.6569 10 45V9ZM42 9V12H19C17.3431 12 16 13.3431 16 15V46H13C12.4477 46 12 45.5523 12 45V9C12 8.44772 12.4477 8 13 8H41C41.5523 8 42 8.44772 42 9ZM18 51V15C18 14.4477 18.4477 14 19 14H47C47.5523 14 48 14.4477 48 15V51C48 51.5523 47.5523 52 47 52H19C18.4477 52 18 51.5523 18 51Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementsRules);
export default __webpack_public_path__ + "static/media/requirements-rules.40c5d368.svg";
export { ForwardRef as ReactComponent };